/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

export const i18n_start_your_free_trial_to_watch: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Start your free membership trial now to watch this, plus thousands of other yoga classes and courses.`,
    es: `Comienza ahora tu suscripción gratuita para acceder a esta y miles de clases y cursos de yoga más.`,
  };
  return phrases[locale] || phrases.en || ``;
};
